import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

import { ConfigContainer } from 'components'
import { Title, Container, Text } from 'components/Form'
import { librarian, message } from 'state_management'
import { AiOutlineExclamation } from 'react-icons/ai'


export default function ChatbotConfig({ customerAdminView = false, chatbotData, onCancel }) {
  const dispatch = useDispatch()

  const [name, setName] = useState(chatbotData ? chatbotData.name : "")
  const [systemPrompt, setSystemPrompt] = useState(chatbotData ? chatbotData.systemPrompt : "")
  const role = useSelector((state) => state.auth.role)

  const onSubmit = () => {
    const input = { name, systemPrompt }
    if (systemPrompt.length > 1200) {
      return dispatch(message.error("Prompt too long (max is 1200 characters)"))
    }
    if (name.length > 100) {
      return dispatch(message.error("Name too long (max is 100 characters)"))
    }
    if (chatbotData) {
      if (role !== "planner") {
        return dispatch(librarian.editAdminChatbot(chatbotData.id, input)).then(onCancel)
      } else {
        dispatch(librarian.editChatbot(chatbotData.id, input)).then(onCancel)
      }
    } else {
      if (role !== "planner") {
        if (customerAdminView) {
          return dispatch(librarian.createGlobalChatbot(input)).then(onCancel)
        } else {
          return dispatch(librarian.createAdminChatbot(input)).then(onCancel)
        }
      } else {
        dispatch(librarian.createChatbot(input)).then(onCancel)
      }
    }
  }
  return (
    <ConfigContainer
      title={chatbotData ? "Edit chatbot" : "Create chatbot"}
      submitHandler={onSubmit}
      cancelHandler={onCancel}
      keyWordForAllowedDeletion="DELETE"
      deleteHandler={chatbotData ? (allowDeletion) => {
        if (allowDeletion === "DELETE") {
          if (chatbotData) {
            dispatch(librarian.deleteChatbot(chatbotData.id)).then(onCancel)
          }
        } else {
          dispatch(message.info("You did not spell DELETE properly"))
        }
      } : undefined}
    >
      <Container>
        <Title>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <span>Chatbot Name</span>
            {name.length > 100 && (
              <AiOutlineExclamation
                style={{ color: "red", marginTop: "4px" }}
                size={40}
                title="Name too long (max is 100 characters)"
              />
            )}
          </div>
        </Title>
        <Text value={name} required onChange={setName} />
      </Container>
      <Container>
        <Title>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <span>System prompt</span>
            {systemPrompt.length > 1200 && (
              <AiOutlineExclamation
                style={{ color: "red", marginTop: "4px" }}
                size={40}
                title="Prompt too long (max is 1200 characters)"
              />
            )}
          </div>
        </Title>
        <Text placeholder={"Write a short description of how the chatbot should behave."}
        large={true} value={systemPrompt} onChange={setSystemPrompt} />
      </Container>
    </ConfigContainer>
  )
}
